import { ICartItem } from '../../../cart/core/interfaces/ICartItem';

export type ExternalVoucherTicketPickerBlockReason = 'no-tickets' | 'needs-ticket-picker';

export interface IExternalVoucherTicketPickerDecision {
  canContinueWithoutPicker: boolean;
  reason?: ExternalVoucherTicketPickerBlockReason;
}

export function externalVoucherTicketPickerDecision(tickets: ICartItem[]): IExternalVoucherTicketPickerDecision {
  if (tickets.length === 0) {
    return { canContinueWithoutPicker: false, reason: 'no-tickets' };
  }

  if (tickets.length === 1) {
    return { canContinueWithoutPicker: true };
  }

  const firstKey = ticketValueKey(tickets[0]);
  const allSameValue = tickets.every(t => ticketValueKey(t) === firstKey);

  if (allSameValue) {
    return { canContinueWithoutPicker: true };
  }

  return { canContinueWithoutPicker: false, reason: 'needs-ticket-picker' };
}

function ticketValueKey(ticket: ICartItem): string {
  const showKey = ticket.showId > 0 ? ticket.showId : 0;
  const valueCents = Math.round(Math.abs(ticket.totalPrice) * 100);
  return `${showKey}:${valueCents}`;
}
